import { User } from '@angular/fire/auth';

export class LoggedInAction {
  public static readonly type = '[Authentication] LoggedInAction';
  constructor(public readonly user: User) {}
}
